import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-background px-6 text-center">
      <Logo size="h-8" />
      <Compass className="h-8 w-8 text-muted-foreground" />
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
        <p className="mt-2 max-w-sm text-sm text-muted-foreground">
          The page you are looking for does not exist or you may not have access to it.
        </p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Button asChild data-testid="notfound-dashboard-button">
          <Link to="/dashboard">Go to my dashboard</Link>
        </Button>
        <Button asChild variant="secondary">
          <Link to="/login">Sign in</Link>
        </Button>
      </div>
    </div>
  );
}
